import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, GeoJSON, LayersControl, useMapEvent, WMSTileLayer } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapHomeControl, MapInfoControl, MapLegendControl } from "../../../../common/MapControls/MapControls";

const INITIAL_VIEW_STATE = {
  longitude: 125.7275,
  latitude: -8.8742,
  zoom: 8,
};

// GeoServer WMS Base URL
const WMS_URL = "http://drr-geoserver.rimes.int/geoserver/drr-dss/wms";

// WMS Layers List
const WMS_LAYERS = [
  // {
  //   name: "Coastal Erosion",
  //   layer: "drr-dss:cyclone_01_input_agriculture_majority_Coastal_erosion_1987_2021",
  // },
  // {
  //   name: "Drought CDD",
  //   layer: "drr-dss:cyclone_01_input_agriculture_majority_Drought_CDD_CC_year_rt100",
  // },
  {
    name: "Inland Flood",
    layer: "drr-dss:agriculture_majority_inl_flood_CC_rt100_6h",
  },
];

const WMSFeatureInfo = () => {
  const map = useMapEvent("click", async (e) => {
    const { lat, lng } = e.latlng;
    const point = map.latLngToContainerPoint(e.latlng);
    const bbox = map.getBounds().toBBoxString();

    const params = new URLSearchParams({
      service: "WMS",
      version: "1.1.1",
      request: "GetFeatureInfo",
      layers: WMS_LAYERS.map((layer) => layer.layer).join(","),
      query_layers: WMS_LAYERS.map((layer) => layer.layer).join(","),
      info_format: "application/json",
      bbox: bbox,
      width: map.getSize().x,
      height: map.getSize().y,
      x: Math.floor(point.x),
      y: Math.floor(point.y),
      srs: "EPSG:4326",
    });

    const url = `${WMS_URL}?${params.toString()}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data.features && data.features.length > 0) {
        const popupContent = data.features
          .map((feature) =>
            Object.keys(feature.properties)
              .map((key) => `<b>${key}</b>: ${feature.properties[key]}`)
              .join("<br />")
          )
          .join("<hr />");

        L.popup()
          .setLatLng([lat, lng])
          .setContent(popupContent || "No data available")
          .openOn(map);
      } else {
        L.popup().setLatLng([lat, lng]).setContent("No data available").openOn(map);
      }
    } catch (error) {
      console.error("Error fetching WMS feature info:", error);
    }
  });

  return null;
};

const AgricultureData = () => {
  const [boundaryData, setBoundaryData] = useState(null);
  const [inlandFloodData, setInlandFloodData] = useState(null);

  useEffect(() => {
    // Load Country Boundary GeoJSON
    fetch("/DATA/OSMbased_adm0_boundary.json")
      .then((res) => res.json())
      .then((boundary) => {
        setBoundaryData(boundary);
      })
      .catch((error) => console.error("Error loading GeoJSON data:", error));

    // Load Inland Flood GeoJSON (If Available)
    fetch("/DATA/Inland_Flood.json") // Replace with the actual GeoJSON path
      .then((res) => res.json())
      .then((floodData) => {
        setInlandFloodData(floodData);
      })
      .catch((error) => console.error("Error loading Inland Flood GeoJSON:", error));
  }, []);

  return (
    <div className="wind-speed-cyclone-container">
      <div className="map-container-WindSpeedCyclone">
        <MapContainer
          center={[INITIAL_VIEW_STATE.latitude, INITIAL_VIEW_STATE.longitude]}
          zoom={INITIAL_VIEW_STATE.zoom}
          className="mapcontainerall"
        >
          <MapHomeControl />
          <MapInfoControl text="Agricultural land exposure to flood hazard across Timor-Leste." />
          {/* Layer toggle control */}
          <LayersControl position="topright">
            {/* Base Layers */}
            <LayersControl.BaseLayer name="White Theme" checked>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="OSM">
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </LayersControl.BaseLayer>

            {/* GeoJSON Layer for Country Boundary */}
            {boundaryData && (
              <LayersControl.Overlay name="Timor Boundary" checked>
                <GeoJSON
                  data={boundaryData}
                  style={{
                    color: "#87CEFA", // Light Blue
                    weight: 2,
                    opacity: 0.8,
                    fillOpacity: 0,
                  }}
                />
              </LayersControl.Overlay>
            )}

            {/* Inland Flood GeoJSON Outline */}
            {inlandFloodData && (
              <LayersControl.Overlay name="Inland Flood Outline">
                <GeoJSON
                  data={inlandFloodData}
                  style={{
                    color: "#2a83ba", // Custom Deep Blue
                    weight: 3,
                    opacity: 1,
                    fillOpacity: 0,
                  }}
                />
              </LayersControl.Overlay>
            )}

            {/* GeoServer WMS Layers */}
            {WMS_LAYERS.map(({ name, layer }) => (
              <LayersControl.Overlay key={layer} name={`${name}`} checked>
                <WMSTileLayer
                  url={WMS_URL}
                  layers={layer}
                  format="image/png"
                  transparent={true}
                  version="1.1.1"
                  tileSize={256}
                  opacity={1}
                  zIndex={1000}
                />
              </LayersControl.Overlay>
            ))}
          </LayersControl>

          {/* Handle clicks to fetch WMS data */}
          <WMSFeatureInfo />

          {/* Legend */}
          <MapLegendControl
            sections={[{
              shape: "square",
              items: [
                { label: "Timor Boundary", color: "#87CEFA" },
                { label: "Inland Flood", color: "#2a83ba" },
              ],
            }]}
          />
        </MapContainer>
      </div>
    </div>
  );
};

export default AgricultureData;